import request from 'tools/request'
import {
  ActiveDriversChartData,
  ActiveVehiclesChartData,
  Driver,
  RecentTeamDriving,
  TeamDrivingChartData,
  TopDriverMileageGraphData,
  VehicleAssignment,
} from 'interfaces/IDrivers'

const getActiveDriversChartData = async (
  carrierId: number
): Promise<ActiveDriversChartData> => {
  const response = await request.get<ActiveDriversChartData>(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}fleet-drivers/summary/active-drivers`,
    {
      params: {
        carrierId,
      },
    }
  )
  return response.data
}

const getActiveVehiclesChartData = async (
  carrierId: number
): Promise<ActiveVehiclesChartData> => {
  const response = await request.get<ActiveVehiclesChartData>(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}fleet-drivers/summary/active-vehicles`,
    {
      params: {
        carrierId,
      },
    }
  )
  return response.data
}

const getRecentTeamDrivingChartData = async (
  carrierId: number
): Promise<TeamDrivingChartData> => {
  const response = await request.get<TeamDrivingChartData>(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}fleet-drivers/summary/recent-team-driving`,
    {
      params: {
        carrierId,
      },
    }
  )
  return response.data
}

const getAverageMilesByDriver = async (carrierId: number): Promise<number> => {
  const response = await request.get<number>(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}fleet-drivers/summary/average-miles-by-driver`,
    {
      params: {
        carrierId,
      },
    }
  )
  return response.data
}

const getTopDriverMileageGraphData = async (
  carrierId: number
): Promise<TopDriverMileageGraphData> => {
  const response = await request.get<TopDriverMileageGraphData>(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}fleet-drivers/top-driver-mileage`,
    {
      params: { carrierId },
    }
  )
  return response.data
}

const getDriverList = async (carrierId: number): Promise<Driver[]> => {
  const response = await request.get<Driver[]>(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}fleet-drivers/drivers`,
    {
      params: {
        carrierId,
      },
    }
  )
  return response.data
}

const getVehicleAssignments = async (
  carrierId: number
): Promise<VehicleAssignment[]> => {
  const response = await request.get<VehicleAssignment[]>(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}fleet-drivers/vehicle-assignments`,
    {
      params: {
        carrierId,
      },
    }
  )
  return response.data
}

const getRecentTeamDriving = async (
  carrierId: number
): Promise<RecentTeamDriving[]> => {
  const response = await request.get<RecentTeamDriving[]>(
    `${process.env.REACT_APP_CARRIER_API_URL_V2}fleet-drivers/recent-team-driving`,
    {
      params: { carrierId },
    }
  )
  return response.data
}

export {
  getActiveDriversChartData,
  getActiveVehiclesChartData,
  getRecentTeamDrivingChartData,
  getAverageMilesByDriver,
  getTopDriverMileageGraphData,
  getDriverList,
  getVehicleAssignments,
  getRecentTeamDriving,
}
